import { render, staticRenderFns } from "./TransferRate.vue?vue&type=template&id=3495bdbe&scoped=true"
import script from "./TransferRate.vue?vue&type=script&lang=js"
export * from "./TransferRate.vue?vue&type=script&lang=js"
import style0 from "./TransferRate.vue?vue&type=style&index=0&id=3495bdbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495bdbe",
  null
  
)

export default component.exports